const CONTACT_TYPES = {
  USER: 'user',
  SUPERVISOR: 'supervisor',
  EMERGENCY: 'emergency',
};

export default CONTACT_TYPES;
